export const setUserData= async (user : any) => {

  window.localStorage.setItem("user", user);
};

export const is401Error= async (e : any) => {

  if(e.response && e.response.status === 401) return true;
  return false;
};